import { useState, useRef, useCallback, SetStateAction } from 'react';

const isFunction = <S,>(setStateAction: SetStateAction<S>): setStateAction is (prevState: S) => S =>
  typeof setStateAction === 'function';

// const useStateRef = <S,>(initialState?: S | (() => S)) => {
function useStateRef(initialState) {
  const [state, setState] = useState(initialState);
  const ref = useRef(state);

  const dispatch: typeof setState = useCallback((setStateAction: any) => {
    ref.current = isFunction(setStateAction) ? setStateAction(ref.current) : setStateAction;

    setState(ref.current);
  }, []);

  return [state, dispatch, ref];
}

export default useStateRef;
